<template>
  <div class="submit-form-container">
    <div class="form-informations">
      <div class="form-header">
        <img src="http://glhcdn.oss-cn-hangzhou.aliyuncs.com/ac/img/20171129/151194008028920171129151019.png">
      </div>
      <div class="form-main">

        <span @click='company'>上市公司
          <br>工作人员</span>
        <span @click='personal'>个人参会
          <br>报名 </span>
      </div>
      <div class="meeting-contact">
        <h3>| 活动须知 | </h3>
        <div class="contact-info">
          <div>为了您能顺利通过审核参加活动，请按要求上传名片并填写真实信息。格隆汇承诺参会信息仅用于本次活动联络需求，绝不对外公开</div>
          <div>我们将在会议开始前3-5天通过短信的形式告知报名结果，请您留意。</div>
          <div>若您在报名期间有任何疑问，请联系格隆汇商务部。</div>
          <div>Tel：0755-86332033 ，电邮：business@gelonghui.com</div>
        </div>
      </div>





      <div class="form-footer">
        <img src="/static/ft.jpg">
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      personal() {
        this.$router.push("/meetings/hkstocks")
      },
      company() {
        window.location.href = 'http://cn.mikecrm.com/zUUKrym'
      }
    },
    mounted() {
      window.document.title = '选择报名类型'
    }
  }

</script>
<style scoped>
  .form-main {
    display: flex;
    width: 100%;
    margin: 2rem 0;
    align-content: space-between
  }

  .form-main span {
    flex-grow: 2;
    text-align: center;
    padding: 0.5rem;
    background: rgb(185, 58, 40);
    cursor: pointer;
    border-radius: 5px;
    margin: 0.8rem;
    color: white;
    font-size: 25px;
  }

  .submit-form-container {
    background: url(https://asset.mikecrm.com/getimg/origin/images/formTemplate/img-bmsq-0-0.jpg) repeat;
    height: auto;
    display: block;
    width: 100%;
    position: absolute;
    font-size: 14px;
  }

  .form-informations {
    max-width: 560px;
    width: 100%;
    background: #FFF;
    margin: 0 auto;
  }

  .form-header h1,
  .form-header p {
    color: rgb(255, 255, 255);
    font-family: 微软雅黑;
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    text-shadow: rgba(0, 0, 0, 0.2) 0px 2px 2px;
    text-align: center;
  }

  .form-header img {
    width: 100%;
    height: auto;
    display: block;
  }

  .form-footer img {
    width: 100%;
    height: auto;
    display: block;
  }

  .meeting-contact h3 {
    border-bottom: 1px solid #666;
    font-weight: 700;
    font-size: 14px;
    line-height: 30px;
    margin: 10px 20px;
  }

  .contact-info div {
    color: #696969;
    font-size: 12px;
    line-height: 14px;
    line-height: 30px;
    margin: 0px 20px;
  }

  .meeting-contact {
    margin: 10px auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/frontend/midGuide.vue